import { render, staticRenderFns } from "./status-area.vue?vue&type=template&id=679787ad&scoped=true&lang=pug&"
import script from "./status-area.vue?vue&type=script&lang=ts&"
export * from "./status-area.vue?vue&type=script&lang=ts&"
import style0 from "./status-area.vue?vue&type=style&index=0&id=679787ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679787ad",
  null
  
)

export default component.exports